var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { Controller } from "@hotwired/stimulus";
const ACTIVE_UPLOADS_SELECTOR = "[data-active-uploads]";
const FILE_SELECTOR = "[data-filename]";
const CONFIRM_SELECTOR = "[data-confirm]";
const LIST_CLASS = "pt-confirm-attachments";
export default class response_confirmation_controller_default extends Controller {
  connect() {
    this.confirmables = Array.from(this.element.querySelectorAll(CONFIRM_SELECTOR));
    this.containers = Array.from(this.element.querySelectorAll(ACTIVE_UPLOADS_SELECTOR));
    if (this.confirmables.length === 0 || this.containers.length === 0) return;
    this.baseMessages = new Map(
      this.confirmables.map((element) => [element, element.getAttribute("data-confirm") || ""])
    );
    this.observer = new MutationObserver(() => this.refresh());
    this.containers.forEach((container) => this.observer.observe(container, { childList: true, subtree: true }));
    this.refresh();
  }
  disconnect() {
    if (this.observer) this.observer.disconnect();
  }
  refresh() {
    const files = this.attachedFiles();
    this.confirmables.forEach((element) => {
      const base = this.baseMessages.get(element) || "";
      this.setConfirm(element, files.length === 0 ? base : base + this.listMarkup(files));
    });
  }
  attachedFiles() {
    return this.containers.flatMap(
      (container) => Array.from(container.querySelectorAll(FILE_SELECTOR)).map((element) => ({
        name: element.getAttribute("data-filename"),
        signedId: element.getAttribute("data-hidden-field")
      }))
    ).filter((file) => file.name);
  }
  // Built through the DOM rather than string concatenation: file names come
  // from whatever the participant uploaded and end up injected as HTML.
  listMarkup(files) {
    const wrapper = document.createElement("div");
    wrapper.className = LIST_CLASS;
    if (this.hasHeadingValue) {
      const heading = document.createElement("p");
      heading.textContent = this.headingValue;
      wrapper.appendChild(heading);
    }
    const list = document.createElement("ul");
    files.forEach((file) => {
      const item = document.createElement("li");
      item.appendChild(this.fileNode(file));
      list.appendChild(item);
    });
    wrapper.appendChild(list);
    return wrapper.outerHTML;
  }
  // An attachment saved on a previous response comes back with its record id
  // instead of a signed id, and there is no URL to build from that on the
  // client, so it is listed without a link.
  fileNode(file) {
    if (!file.signedId) return document.createTextNode(file.name);
    const link = document.createElement("a");
    link.href = `/rails/active_storage/blobs/redirect/${encodeURIComponent(file.signedId)}/${encodeURIComponent(file.name)}`;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.textContent = file.name;
    return link;
  }
  // jQuery caches `data-*` on first read, and that is how core's ConfirmDialog
  // reads the message, so the attribute alone is not enough to guarantee the
  // dialog sees an update.
  setConfirm(element, message) {
    element.setAttribute("data-confirm", message);
    if (window.jQuery) window.jQuery(element).data("confirm", message);
  }
}
__publicField(response_confirmation_controller_default, "values", {
  heading: String
});
